import { Http } from '@/services/http'
import { Injectable } from '@tanbo/vue-di-plugin'
import { Group } from '@/views/dashboard/_type/group'

export interface TerminalGroupRes {
  /** 终端分组 */
  group: Group
}

@Injectable()
export class UsedGroupService {
  constructor (private http: Http) {
  }

  getTerminalGroup (data: { strategy_id: string, strategy_type: number }) {
    return this.http.post<TerminalGroupRes>('/terminal-group/group-by-id', data)
  }
}
